<template>
  <div class="upload-image-wrapper">
    <van-cell :title="title" :label="descrition" :border="false" />
    <div class="upload-image-container">
      <div class="left-upload">
        <upload-image
          width="calc(50vw - 28px)"
          height="90px"
          :imageUrl="resource.imageUrl"
          @success="uploadImageSuccess"
          @delete="deleteImage"
        ></upload-image>
      </div>
      <div class="right-example" v-if="resource.category != 4 && resource.category != 7">
        <img :src="exampleUrl" class="example-img" />
        <div class="tag">示例</div>
      </div>
    </div>
  </div>
</template>

<script>
import uploadImage from './uploadImage';
import { createLivePhotoCategory } from '@/utils/commonData.js';
export default {
  components: { uploadImage },
  props: ['resource'],
  data() {
    return {};
  },
  computed: {
    title() {
      return createLivePhotoCategory.get(this.resource.category).title || '';
    },
    descrition() {
      return createLivePhotoCategory.get(this.resource.category).desc || '';
    },
    exampleUrl() {
        return createLivePhotoCategory.get(this.resource.category).exampleUrl || '';
    },
  },
  created() {
    console.log(this.resource);
  },
  methods: {
    uploadImageSuccess(imageResult) {
      const newResult = Object.assign(this.resource, imageResult);
      this.$emit('success', newResult);
    },
    deleteImage() {
      this.$emit('delete', this.resource);
    },
  },
};
</script>

<style lang="less" scoped>
@import url('~@/assets/css/liveShopCommon.less');

// 上传卡片的大小
.preview-item-size {
  width: calc(50vw - 28px);
  max-width: 355px;
  height: 90px;
}
.upload-image-wrapper {
  width: 100%;
  /deep/ .van-cell {
    padding: 0;
    padding-bottom: 5px;
  }
  .upload-image-container {
    width: 100%;
    display: flex;
    justify-content: space-between;
    box-sizing: border-box;
    padding: 10px 0;

    .left-upload {
      .preview-item-size;
      overflow: hidden;
      background: #f8f8f8;
      border: 1px dashed #dadada;
      border-radius: 4px;
      position: relative;

      .camera-img {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translateX(-50%) translateY(-50%);
        width: 40px;
        height: 40px;
        object-fit: cover;
        pointer-events: none;
      }
    }
    .right-example {
      .preview-item-size;
      position: relative;
      border-radius: 4px;
      overflow: hidden;
      .example-img {
        width: 100%;
        height: 100%;
        // object-fit: contain;
      }
      .tag {
        position: absolute;
        overflow: hidden;
        bottom: 0;
        right: 0;
        width: 32px;
        height: 18px;
        font-size: 10px;
        text-align: center;
        border-top-left-radius: 3px;
        line-height: 18px;
        color: white;
        background: #f34e4e;
      }
    }
    &::after {
      position: absolute;
      box-sizing: border-box;
      content: ' ';
      pointer-events: none;
      right: 0;
      bottom: 0;
      left: 0;
      border-bottom: 1px solid #ebedf0;
      transform: scaleY(0.5);
    }
  }
}
</style>
